import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
    const { data, error } = await supabase.from('studentlessonsview').select().order('lessonName', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataWithType(type) {
    const { data, error } = await supabase.from('studentlessonsview').select().eq('type',type).order('lessonName', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  

  export async function getIdData(id) {
    const { data, error } = await supabase.from('studentlessonsview').select()
    .eq('id', id).order('lessonName', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getStudentIdData(id) {
    const { data, error } = await supabase.from('studentlessonsview').select()
    .eq('studentId', id).order('lessonName', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  
  export async function getStudentIdWithClassData(id,sclass) {
    const { data, error } = await supabase.from('studentlessonsview').select()
    .eq('studentId', id)
    .eq('class', sclass)
    .eq('isActive', true);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }




  export async function addData(adata) {
    const { data, error } = await supabase.from('studentlessonsview').insert(adata).select();

    console.log("error",error,data);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    
    const { data, error } = await supabase.from('studentlessonsview').update(udata).eq('id', udata.id).select();
    console.log("udata",udata,data,error);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('studentlessonsview').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }